/** Regex * */
export const formFormatterRegex = {
  notAllowNumeric: /\d+/g,
  allowOnlyNumeric: /[^0-9]/g,
  allowOnlyLettersAndQuote: /[^a-z ']/gi,
  allowOnlyLettersAndQuoteDash: /[^a-z '-]/gi,
  allowOnlyLettersAndSpace: /[^a-z ]/gi,
  allowOnlyLetters: /[^a-z]/gi,
  allowOnlyLettersAndNumeric: /[^a-z0-9]/gi,
  allowOnlyLettersAndNumericAndSpace: /[^a-z0-9 ]/gi,
  allowOnlyLettersNumericDashOrPeriod: /[^a-z0-9 .-]/gi,
  allowOnlyLettersCommaAndPeriod: /[^a-z .,]/gi,
};
